import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';
import { HttpWrapper } from './http-wrapper';

@Injectable({
  providedIn: 'root',
})
export class MemberLedger {
  private memberMobileApiUrl = environment.memberMobileApiUrl;
  private baseUrl = environment.apiUrl;
  private posSaleUrl = environment.posSaleUrl;

  constructor(
    private http: HttpClient,
    private httpWrapper: HttpWrapper,
  ) {}

  getMemberMonthlyBilling(
    memberCode?: any,
    fromDate?: any,
    toDate?: any,
    searchText?: any,
    currency?: any,
  ): Observable<any> {
    // Disabled: `${this.memberMobileApiUrl}member/get-member-transactions`
    const baseUrl = `${this.memberMobileApiUrl}member/get-member-transactions`;

    let params = new HttpParams();

    if (searchText !== undefined && searchText !== null && searchText != '') {
      params = params.set('SearchText', searchText.toString());
    }

    if (memberCode != '' && memberCode != undefined && memberCode != null) {
      params = params.set('MemberCode', memberCode);
    }

    if (fromDate != '' && fromDate != undefined && fromDate != null) {
      params = params.set('fromDate', fromDate);
    }

    if (toDate != '' && toDate != undefined && toDate != null) {
      params = params.set('todate', toDate);
    }

    if (currency != '' && currency != undefined && currency != null) {
      params = params.set('currencyType', currency);
    }

    return this.httpWrapper.get(baseUrl, params);
  }

  createPayment(data: any): Observable<any> {
    const headers = new HttpHeaders({
      memberCode: data?.memberCode ?? '',
    });
    let memberApp = 'MEMBERAPP';
    return this.http.post(
      `${this.memberMobileApiUrl}payment/create-payment-order-for-member`,
      data,
      { headers },
    );
  }

  decryptPayment(encryptedAmount?: any, encryptedLink?: any): Observable<any> {
    let params: string[] = [];

    if (encryptedAmount != '' && encryptedAmount != undefined && encryptedAmount != null) {
      params.push(`EncryptedAmount=${encryptedAmount}`);
    }

    if (encryptedLink != '' && encryptedLink != undefined && encryptedLink != null) {
      params.push(`EncryptedLink=${encryptedLink}`);
    }

    const queryString = params.length ? `?${params.join('&')}` : '';

    return this.httpWrapper.get<any>(
      `${this.memberMobileApiUrl}payment/decrypt-payment${queryString}`,
    );
  }

  getMonthlyInvoiceDetails(memberCode?: any, currencyType?: any): Observable<any> {
    const code = encodeURIComponent(memberCode?.trim() ?? '');
    return this.http.get(
      `${this.memberMobileApiUrl}invoice/get-monthly-invoice-details?memberCode=${code}&currencyType=${currencyType}`,
    );
  }

  /** @deprecated Use getMonthlyInvoiceDetails */
  getAllMonthily(memberCode: string): Observable<any> {
    return this.getMonthlyInvoiceDetails(memberCode);
  }

  downloadMonthlyInvoice(
    memberCode: string,
    date: string,
    invoiceNo: string,
    currency: string,
  ): Observable<any> {
    const code = encodeURIComponent(memberCode?.trim() ?? '');
    const invoiceDate = encodeURIComponent(date?.trim() ?? '');

    const invoiceParamName = currency?.toUpperCase() === 'USD' ? 'invoiceNoForUSD' : 'invoiceNo';

    const params = new HttpParams()
      .set('memberCode', memberCode?.trim() ?? '')
      .set('date', date?.trim() ?? '')
      .set(invoiceParamName, invoiceNo ?? '');

    return this.http.get(`${this.memberMobileApiUrl}invoice/download-monthly-invoice`, { params });
  }
}
